import { render, staticRenderFns } from "./widgetSecThreat.vue?vue&type=template&id=2a773099&scoped=true&"
import script from "./widgetSecThreat.vue?vue&type=script&lang=js&"
export * from "./widgetSecThreat.vue?vue&type=script&lang=js&"
import style0 from "./widgetSecThreat.vue?vue&type=style&index=0&id=2a773099&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a773099",
  null
  
)

export default component.exports